<template>
  <img class="img" :src="src" :alt="info.name"
       :style="imgStyle"
       @click="onClick"/>
</template>

<script>
import {calcRem750} from "@/pages/Campaign/utils/calcRem"
import {imgUrl} from "@/pages/Campaign/utils/img"
import {jumpUrl, jump} from "@/pages/Campaign/utils/jump";
import {UNI_ROUTE} from "@/pages/Campaign/utils/uniRoute";
import _ from 'lodash'

export default {
  name: "Photo",
  props: {
    info: {
      // 图片名称
      name: String,
      // 图片区块的位置
      poi: Number,
      // 点击跳转详情数据
      jump: Object,
      // 图片数据
      img: Object,
      // 置顶校准偏移量
      offset: Number,
      route: Object
    }
  },
  data() {
    return {
      src: undefined
    }
  },
  mounted() {
    setTimeout(() => {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.src = imgUrl(this.info.img)
          observer.disconnect()
        }
      })

      observer.observe(this.$el)
      // 使头图先加载占位，不会立即触发后面图片的加载
    }, this.info.poi === 0 ? 0 : 100)
  },
  computed: {
    imgStyle() {
      let height = '0'
      if (this.info?.img) {
        height = calcRem750(this.info.img.height || 0)
      }
      return {
        width: '100%',
        height: height,
        minHeight: height
      }
    }
  },
  methods: {
    onClick() {
      if (!this.info.jump && !this.info.route) return
      if (this.info.route) {
        if (!_.isEmpty(this.$route.query) && !_.isEmpty(this.info.route.arg.linkUrl)) {
          const linkUrl = this.info.route.arg.linkUrl
          const { x_stream_id } = this.$route.query
          this.info.route.arg.linkUrl = linkUrl.indexOf('?') > -1 ? `${linkUrl}&x_stream_id=${x_stream_id}` : `${linkUrl}?x_stream_id=${x_stream_id}`
        }
        UNI_ROUTE.route(this.info.route, (url) => {
          this.onPhotoClickSensor(url, this.info.route.brand)
        })
      } else {
        const url = jumpUrl(this.info.jump)
        this.onPhotoClickSensor(url, this.info.jump.brand)
        jump(url)
      }
    },
    onPhotoClickSensor(url, brand) {
      const isHeaderPhoto = this.info.poi === 0
      // 头图下标为 1 ，详情图片下标从 1 开始
      const sensorPoi = isHeaderPhoto ? 1 : this.info.poi - 1

      this.$sensors.track('content_click', {
        page_name: `承接页-${document.title}`,
        module_name: isHeaderPhoto ? '头图' : '详情图',
        content_url: url,
        jump_brand_name: brand,
        cur_spm: `1001.${this.$route.params.id}.${isHeaderPhoto ? 'loc1' : 'loc3'}.${sensorPoi}`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.img {
  margin-top: -1px;
  content-visibility: auto;
  background-color: #f0f0f0;
  background-image: url('~@/pages/Campaign/assets/load-img.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 24% auto;
}
</style>
